const mod = require('../bahabot.module.js')

mod.factory('ThemeService', ["$window", function($window) {
    var storageKey = 'bahabot_theme'
    var isDark

    function readPreference() {
        var stored = $window.localStorage.getItem(storageKey)
        if (stored !== null) {
            return stored === 'dark'
        }
        return $window.matchMedia('(prefers-color-scheme: dark)').matches
    }

    function apply() {
        if (isDark) {
            $window.document.documentElement.classList.add('dark')
        } else {
            $window.document.documentElement.classList.remove('dark')
        }
    }

    isDark = readPreference()
    apply()

    return {
        get isDark() {
            return isDark
        },

        toggle: function() {
            isDark = !isDark
            $window.localStorage.setItem(storageKey, isDark ? 'dark' : 'light')
            apply()
        }
    }
}])
